import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gray-50 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-gray-600 mb-6">
              <strong>Last Updated:</strong> January 4, 2026
            </p>
            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Information We Collect</h2>
                <p className="text-gray-600">
                  We collect information you provide when creating an account, including your name, email address, and location preferences to help you find local board game clubs.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">How We Use Your Information</h2>
                <p className="text-gray-600">
                  Your information is used to provide and improve our services, connect you with local clubs, and communicate important updates about BoardVoyage.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Data Security</h2>
                <p className="text-gray-600">
                  We implement industry-standard security measures to protect your personal information. Your data is encrypted and stored securely.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Your Rights</h2>
                <p className="text-gray-600">
                  You have the right to access, update, or delete your personal information at any time. Contact us if you have any privacy concerns.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
